import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import ArticleCard from '@/components/ArticleCard';
import SEO from '@/components/SEO';
import { searchArticles } from '@/lib/api';
import { Loader2, SearchX } from 'lucide-react';

const SearchPage = () => {
  const [searchParams] = useSearchParams();
  const q = searchParams.get('q') || '';
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!q) { setResults([]); setLoading(false); return; }
    setLoading(true);
    searchArticles(q)
      .then((res) => setResults(res.data))
      .catch(() => setResults([]))
      .finally(() => setLoading(false));
  }, [q]);

  return (
    <div className="min-h-screen bg-black page-enter" data-testid="search-page">
      <SEO title={`Search: ${q}`} description={`Search results for "${q}" on Check On Yo Peoples TV`} />
      <Header />

      <main className="max-w-4xl mx-auto px-4 py-6">
        <div className="mb-6 py-6 border border-[#222] bg-[#111] text-center animate-fade-in-up">
          <h1 className="text-xl sm:text-2xl font-bold text-white">
            Results for <span className="text-yellow-500">&ldquo;{q}&rdquo;</span>
          </h1>
          {!loading && (
            <p className="text-gray-500 text-sm mt-1" data-testid="search-results-count">
              {results.length} {results.length === 1 ? 'story' : 'stories'} found
            </p>
          )}
        </div>

        {loading ? (
          <div className="flex items-center justify-center py-20">
            <Loader2 className="w-8 h-8 animate-spin text-yellow-500" />
          </div>
        ) : results.length > 0 ? (
          <div className="grid grid-cols-3 gap-1.5 sm:gap-3 lg:gap-4" data-testid="search-results-grid">
            {results.map((article, idx) => (
              <ArticleCard key={article.id} article={article} index={idx} />
            ))}
          </div>
        ) : (
          <div className="text-center py-20 border border-[#222] bg-[#111]" data-testid="search-empty-state">
            <SearchX size={40} className="mx-auto text-gray-700 mb-3" />
            <p className="text-gray-500">No stories found for &ldquo;{q}&rdquo;.</p>
            <p className="text-gray-600 text-sm mt-2">Try a different keyword.</p>
          </div>
        )}
      </main>

      <Footer />
    </div>
  );
};

export default SearchPage;
